// src/components/About.js
import React, { useEffect, useContext, useState } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import ConfirmationModal from "../modals/ConfirmationModal";
import config from "../../config/config";

const MyReviews = () => {
  const { user, isAuthenticated } = useContext(AppContext);
  const [reviewData, setReviewData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");
  const [icon, setIcon] = useState("");
  const [theme, setTheme] = useState("");


  const token = config.getAuthToken();

  const fetchReviewData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/getMyReviews`,
        { userId: user?.data?.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status) {
        setReviewData(response.data.data); // Assuming 'data' contains the reviews array
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      if (error.response.status === 404) {
        setShowModal(true);
        setMsgTitle("No reviews found for this user");
        setMessage();
        setIcon("fa fa-info-circle");
        setTheme("gold");
      } else {
        setShowModal(true);
        setMsgTitle("Failed to fetch data. Please try again.");
        setMessage();
        setIcon("fa fa-times-circle-o");
        setTheme("red");
      }
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchReviewData();
    }
  }, [isAuthenticated]);

  return (
    <>
      <div className="row ">
        {showModal && (
          <ConfirmationModal
            onClose={() => setShowModal(false)}
            title={msgTitle}
            message={message}
            icon={icon}
            theme={theme}
          />
        )}
      </div>

      <div className="nofltrbx">
        <div className="title-header breadcrumb">
          <div className="profile-path">
            <span>My Review</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyReviews;
